// extracted by mini-css-extract-plugin
module.exports = {"container":"AddPath_container__20R-w","addPathIcon":"AddPath_addPathIcon__3rKrS"};